import { Box } from "@mui/material";
import React, { Fragment } from "react";
import ChangePasswordForm from "../../components/Auth/ChangePasswordForm";

export default function ChangePassword() {
    //console.log("changePassword");
    return (
        <Fragment>
            <Box
                display={"flex"}
                sx={{
                    flexShrink: 0,
                    borderRadius: "2rem 2rem 0rem 0rem",
                    background: "#E5EEF5",
                    // minHeight: "42.25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "70vh",
                }}
            >
                <Box
                    display="flex"
                    sx={{
                        flexDirection: "column",
                        gap: "1rem",

                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <ChangePasswordForm />
                </Box>
            </Box>
        </Fragment>
    );
}
